import React from "react";
import Mockman from "mockman-js";
function MockAPI() {
  return (
    <div className="MockAPI p">
      <Mockman />
    </div>
  );
}

export default MockAPI;
